module.exports = __webpack_public_path__ + "img/play.932064c0.svg";